define('Documents.ItemDetails.View'
    , [
        "Documents.Model"

        , 'documents_itemdetails.tpl'

        , 'Backbone'
    ]
    , function (
        DocumentsModel

        , documents_itemdetails_tpl

        , Backbone
    ) {
        'use strict';

        return Backbone.View.extend({

            template: documents_itemdetails_tpl

            , initialize: function (options) {
                this.pdpComponent = options.container.getComponent('PDP');

                this.model = new DocumentsModel();

                var self = this;

                this.pdpComponent.on('afterShowContent', function () {
                    self.fetchItemSpecification();
                });
            }

            , fetchItemSpecification: function () {
                var self = this;
                var item = this.pdpComponent.getItemInfo().item,
                    itemId = item.internalid,
                    itemDocuments = item.custitem_item_documents;

                if (!!itemDocuments) {
                    this.model.fetch({ data: { itemId: itemId } }).done(function (result) {
                        self.documents = result[0][0];

                        self.render();
                    });
                }
            }

            , getContext: function getContext() {

                return {
                    documents: this.documents
                };
            }
        });
    });
